export const CategoryMenu = {
  BakerLifestyle: 1233,
  ClarkeAndClarke: 1223,
  ColeAndSon: 1230,
  GastonYDaniela: 1228,
  GPAndJBaker: 1229,
  Kravet: 1200,
  KravetBasics: 1222,
  KravetContract: 1226,
  KravetCouture: 1224,
  KravetSmart: 1227,
  LeeJofa: 1225,
  LeeJofaModern: 1231,
  Mullberry: 1232,
  Threads: 1234,
}

export const createVendorEntry = (name: string, category: string, vendorIdMapKey: keyof typeof CategoryMenu) => ({
  name,
  routeParams: {
    categories: [category],
    vendors: [CategoryMenu[vendorIdMapKey]],
  },
})
